import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Traffic cone — the row design marks live for Area; Grid2x2 is the recorded alt.
export const AREA_NODES: IconNode = [
  [
    'path',
    {
      key: 'area-0',
      d: 'M4 19.5H20M9.40002 9.5H14.6M7.79999 14.5H16.2M6 19.5L11 4.5H13L18 19.5',
    },
  ],
]

export const AreaIcon: LucideIcon = createLucideIcon('area', AREA_NODES)
